<div (click)="controlClick()" [ngClass]="{'selected': isSelected}" class="eFormControlContainer"
  [ngStyle]="{'min-width': control.ControlType != 'component' && (control.ControlType == 'textbox' || control.ControlType == 'note' || control.ControlType == 'divider' || control.ControlType == 'dropdown' || control.ControlType == 'date') ? control.Width : ''
    , 'padding-left': control.Indent ? (control.Indent + 'px') : '0px', 'height': control.ControlType == 'verticalDivider' ? '100%': '' }">
  <!-- Edit Header -->
  <div *ngIf="!isDragging" [ngClass]="{'editClick': isSelected, 'hidden': !isSelected}">
    <div style="flex:1;">
      <ng-content></ng-content>
    </div>
    <div>
      <!-- <button mat-icon-button (click)="editClick()"><img id='imgEdit' alt='Edit Element' aria-label='Edit Element'
          src='./assets/images/edit disabled.png' /></button> -->
      <button mat-icon-button (click)="deleteClick()" *ngIf="!control.CannotBeRemoved || isDevMode"><img id='imgDelete' alt='Remove Element'
          aria-label='Remove Element' src='./assets/images/trash disabled.png' /></button>
    </div>
  </div>
    
  <div *ngIf="!control.CustomField" [ngStyle]="{'height': control.ControlType == 'verticalDivider' ? (isSelected ? 'Calc(100% - 50px)' : '100%'): ' '}">
    <!-- Text -->
    <div *ngIf="control.ControlType == 'text'" style='display:flex;' 
      [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}" class="designerControl">
      <quill-editor *ngIf="!control.TextProvidedOnInstance && control.Value" [(ngModel)]="control.Value"
        [readOnly]="true" class="ql-textOnly"></quill-editor>
      <div *ngIf="!control.TextProvidedOnInstance && !control.Value" style='font-style: italic;'>No text entered.</div>
      <div *ngIf="control.TextProvidedOnInstance && control.Instructions">[{{control.Instructions}}]</div>
      <div *ngIf="control.TextProvidedOnInstance && !control.Instructions" style='font-style: italic;'>No instructions
        entered.</div>
    </div>
  
    <!--Horizontal Divider --> 
    <div *ngIf="control.ControlType=='divider'" class="designerControl">
      <!-- control.RemoveBottomPadding may be null, in which case the padding should NOT show. -->
      <mat-divider style="flex:1;" [ngStyle]="{'padding-bottom': control.RemoveBottomPadding == false ? '1.34375em' : '0px'}"></mat-divider>
    </div>

    <!--Vertical Divider --> 
    <div *ngIf="control.ControlType=='verticalDivider'" class="designerControl verticalDividerContainer" [ngStyle]="{'padding-top': control.PaddingTop}">
      <mat-divider vertical class="verticalDivider"></mat-divider>
    </div>

    <!-- Image -->
    <div *ngIf="control.ControlType=='image'" class="designerControl"
      [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}">
      <img [alt]="control.Label ? control.Label : 'Image'"
        [src]="!control.Attachment ? '' : 'data:' + control.Attachment.FileType + ';base64,' + control.Attachment.FileDataBase64 | safeResourceUrl">
    </div>

    <!-- Buttons -->
    <div *ngIf="control.ControlType == 'buttons'" class="designerControl" style="flex-direction: column;"
      [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}">
      <label>{{ !control.HideLabel ? control.Label : ''}}<span *ngIf="control.IsRequired" style="color:red;">&nbsp;*</span></label>
      <mat-chip-list [id]="'chipList' + control.Label">
        <mat-chip [id]="'chip' + chip.Code" *ngFor='let chip of control.DropdownOptions' [value]='chip.Code'>
          {{chip.CodeDescription}}</mat-chip>
      </mat-chip-list>
      <div *ngIf="!control.Label && control.DropdownOptions.length == 0" style="font-style: italic">Buttons: No choices
        provided.</div>
    </div>

    <!-- Checkbox -->
    <div *ngIf="control.ControlType == 'checkbox'" class="designerControl"
      [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}">
      <tyl-checkbox>{{ !control.HideLabel ? control.Label : ''}}<span *ngIf="control.IsRequired" style="color:red;">&nbsp;*</span></tyl-checkbox>
    </div>

    <!-- Checkbox with Textbox -->
    <div *ngIf="control.ControlType == 'checkboxWithTextbox'" class="designerControl"
      [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}">
      <tyl-checkbox>{{ !control.HideLabel ? control.Label : ''}}</tyl-checkbox>
      <tyl-form-field>
        <input matInput id='inpChkTxt' type='text' />
      </tyl-form-field>
    </div>

    <!-- Dropdown -->
    <div *ngIf="control.ControlType == 'dropdown'" style='display:flex;' class="designerControl">
      <tyl-form-field [postLabelSpace]="true" [label]='!control.HideLabel ? control.Label : ""' [ngStyle]="{'width': control.Width ? control.Width : ''}"
        [required]="control.IsRequired">
        <mat-select [id]="'ddl' + control.Label" [required]="control.IsRequired">
          <mat-option *ngFor='let option of control.DropdownOptions' [value]='option.Code'>{{option.CodeDescription}}
          </mat-option>
        </mat-select>
      </tyl-form-field>
    </div>

    <!-- Note -->
    <div *ngIf="control.ControlType == 'note'" class="designerControl">
      <tyl-form-field [postLabelSpace]="true" [label]='!control.HideLabel ? control.Label : ""' [ngStyle]="{'width': control.Width ? control.Width : ''}"
        [required]="control.IsRequired" [hint]="control.MaxLength > 0 ? control.MaxLength - (control.Value ? control.Value.length : 0) + ' characters left': ''">
        <textarea matInput [id]="'txt' + control.Label" [required]="control.IsRequired" [maxLength]="control.MaxLength"
          [rows]="control.NoteRows"></textarea>
      </tyl-form-field>
    </div>

    <!-- Textbox -->
    <div *ngIf="control.ControlType == 'textbox'" class="designerControl">
      <tyl-form-field [postLabelSpace]="true" [label]='!control.HideLabel ? control.Label : ""' [ngStyle]="{'width': control.Width ? control.Width : ''}"
        [required]="control.IsRequired">
        <input matInput [id]="'inp' + control.Label" [type]="control.DataType == 'number' ? 'number' : 'text'"
          [required]="control.IsRequired" />
      </tyl-form-field>
    </div>

    <!-- Radio Buttons -->
    <div *ngIf="control.ControlType == 'radioButtons'" class="designerControl"
      [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}">
      <tyl-radio-group [label]="!control.HideLabel ? control.Label : ''" [values]="radioValues" [labels]="radioLabels" [ids]="radioIds"
        arrange='vertical' [required]="control.IsRequired">
      </tyl-radio-group>
      <div *ngIf="!control.Label && control.DropdownOptions.length == 0" style="font-style: italic">Radio Buttons: No
        choices provided.</div>
    </div>

    <!-- Date -->
    <div *ngIf="control.ControlType == 'date'" class="designerControl">
      <tyl-datepicker [id]="'date' + control.Label" [postLabelSpace]="true" [label]="!control.HideLabel ? control.Label : ''" [truncateLabel]="control.IsRequired"
        [isRequired]="control.IsRequired" [ngStyle]="{'width': control.Width ? control.Width : ''}" [showTodayButton]="control.ShowTodayButton">
      </tyl-datepicker>
    </div>

    <!-- Time -->
    <div *ngIf="control.ControlType == 'time'" class="designerControl">
      <tyl-time-field  [label]="!control.HideLabel ? control.Label : ''"  [id]="'time' + control.Label" [showNowButton]="control.ShowNowButton"
            [name]="'time' + control.Label" [required]='control.IsRequired' [width]="control.Width"
      ></tyl-time-field>
    </div>

    <!-- Attachment -->
    <div *ngIf="control.ControlType == 'attachment'" class="designerControl" style="flex-direction: column;"
      [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}">
      {{!control.HideLabel ? control.Label : ""}}
      <span *ngIf="control.IsRequired" style="color: red; font-weight: bold;">&nbsp;*</span>
      <add-file [(fileString)]="control.Attachment.FileDataBase64" [(fileName)]="control.Attachment.OriginalFileName"
        [(fileExtension)]="control.Attachment.FileExtension" [required]="control.IsRequired"
        [hideRequiredAsterisk]="true" [(fileType)]="control.Attachment.FileType">
      </add-file>
    </div>

    <!-- Link To File -->
    <div *ngIf="control.ControlType == 'linkToFile'" class="designerControl"
      [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}">
      <a class="link">{{control.Label ? control.Label : 'Choose file'}}</a>
    </div>
  </div>

  <div *ngIf="control.CustomField || control.ControlType == 'component'">
    <!-- Custom Field -->
    <div style='display:flex;' class="designerControl" style="flex-direction: column;" *ngIf="control.ControlType != 'component'"
    [ngStyle]="{'padding-bottom': !control.RemoveBottomPadding && (control.ControlType == 'buttons' || control.ControlType == 'radioButtons' || control.ControlType == 'checkbox' || control.ControlType == 'attachment' || control.ControlType == 'text' || control.ControlType == 'image' || control.ControlType == 'linkToFile' || control.ControlType == 'divider') ? '1.34375em' : ''}">
      <!-- <label>{{control.HideLabel ? '' : control.Label}}<span *ngIf="control.IsRequired && !control.HideLabel" style="color:red;">&nbsp;*</span></label> -->
      <div *ngIf="!control.CustomFieldName">Select field</div>
      <div *ngIf="control.CustomFieldName">
        <custom-data-field [fieldName]="control.CustomFieldName" [width]="control.Width" [controlTypeID]="control.CustomFieldControlTypeID" [alwaysShowControl]="true"
          [label]="control.Label" [hideLabel]="control.HideLabel" [required]="control.IsRequired" [hintLabel]="control.HintLabel" [noteRows]="control.NoteRows"
          [showTodayButton]="control.ShowTodayButton" [showNowButton]="control.ShowNowButton"></custom-data-field>
      </div>
    </div>
    <!-- Custom Component -->
    <div class="designerControl" style="flex-direction: column;display:flex;" *ngIf="control.ControlType == 'component'">
      <ng-container *ngTemplateOutlet="contentTemplate;"></ng-container>
    </div>
  </div>

</div>
